import { render, staticRenderFns } from "./TransactionLogPurchases.vue?vue&type=template&id=005691a4"
import script from "./TransactionLogPurchases.vue?vue&type=script&lang=js"
export * from "./TransactionLogPurchases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports